import { batch } from "react-redux";
import cloneDeep from "lodash.clonedeep";
import types from "./actionTypes";
import { getClusterlets } from "../clusterlets/selectors";
import { getTransaction, getSelectedTransactions, getAllTransactions, getNestedTransactions } from "./selectors";
import { setSelectedTransactionId, handleSnackBar } from "../../global/actions";
import { dealWithTransactions, dealWithNestedTransactions, dealWithInvokedTransaction, dealWithTemplateTransaction, clusterletsOfSelectedTransaction, dealWithReorderClusterlet } from '../../undoredo/actions'
import { getTransactionEvents, getClusterletEvents } from '../../constructs/events/selectors'
import { deleteEvent, deleteEventOnly } from '../../constructs/events/actions'
import { getLuaEditorData } from '../../constructs/handlers/selectors';
import { onDeleteLuaFiles } from "../../../store/constructs/handlers/actions";
import { getUserTriggers } from '../../constructs/user_triggers/selectors'
import { getRoutingRules } from '../../constructs/routing_rules/selectors';
import { deleteRrdef } from '../../constructs/routing_rules/actions';
import { deleteUserTrigger } from '../../constructs/user_triggers/actions';

export const addTransaction = (payload) => ({
	type: types.ADD_TRANSACTION,
	payload,
})

export const editTransaction = (payload) => ({
	type: types.EDIT_TRANSACTION,
	payload,
})

export const deleteTransaction = (payload) => ({
	type: types.DELETE_TRANSACTION,
	payload,
})

export const addNestedTransaction = (data, id) => ({
	type: types.ADD_NESTEDTRANSACTION,
	payload: { data, id },
})

export const editNestedTransaction = (payload) => ({
	type: types.EDIT_NESTEDTRANSACTION,
	payload
})

export const nestedTransactionDeletion = (payload) => ({
	type: types.DELETE_NESTEDTRANSACTION,
	payload,
})

export const nestedTransactionLinkDelete = (nestedTransactionId, selectedTransactionId) => ({
	type: types.DELETE_NESTEDTRANSACTION_LINK,
	payload: {
		nestedTransactionId,
		selectedTransactionId
	},
})

export const addInvokedTransaction = (invokedTransaction, selectedTransactionId) => ({
	type: types.ADD_INVOKEDTRANSACTION,
	payload: {
		invokedTransaction,
		selectedTransactionId
	},
})

export const editInvokedTransaction = (invokedTransaction, selectedTransactionId) => ({
	type: types.EDIT_INVOKEDTRANSACTION,
	payload: {
		invokedTransaction,
		selectedTransactionId
	},
})

export const deleteInvokedTransaction = (invokedTransId, selectedTransactionId) => ({
	type: types.DELETE_INVOKEDTRANSACTION,
	payload: {
		invokedTransId,
		selectedTransactionId
	},
})

export const reorderClusterlet = (selectedTransactionId, clusterletArray) => ({
	type: types.REORDER_CLUSTERLETS,
	payload: {
		selectedTransactionId,
		clusterletArray
	},
})

// Actions for transactions
export const onTransctionCreation = (transaction, splitedList, doNotUpdateSelected, noUndoRedo, handlersToAdd, handlersToDelete) => (dispatch, getState) => {

	const allTransactions = getAllTransactions(getState());

	const orgTransaction = allTransactions.find((i) => i.id === transaction.id);

	if (orgTransaction != null && orgTransaction !== undefined) {

		//const orgTransaction = allTransactions[index];

		if (noUndoRedo != true) {
			const clusterletsInOriginal = orgTransaction.clusterlets.map(cl => cl.id);
			const clusterletsInEdited = transaction.clusterlets.map(cl => cl.id);

			//const deletedClusterlet = clusterletsInOriginal.filter(x => !clusterletsInEdited.includes(x)).concat(clusterletsInEdited.filter(x => !clusterletsInOriginal.includes(x)));

			console.log({ clusterletsInOriginal, clusterletsInEdited });

			const deletedClusterlet = [];
			clusterletsInOriginal.forEach(cOrg => {
				let deletedId = clusterletsInEdited.find(cEd => cEd == cOrg);
				if (deletedId == undefined) {
					deletedClusterlet.push(cOrg);
				}
			})

			console.log({ deletedClusterlet });

			const clusterletEvents = getClusterletEvents(deletedClusterlet, getState());
			const clusterletEventsIds = clusterletEvents.map(cl => cl.id)
			let luaCodeData = getLuaEditorData(getState());
			let userTriggers = getUserTriggers(getState());
			let rrdefs = getRoutingRules(getState())

			console.log({ deletedClusterlet, clusterletEvents })

			const dependEvents = [];
			const nestedTransEvents = [];
			let eventAssociatedData = {};

			transaction.events.forEach(event => {
				clusterletEvents.forEach(cl => {
					if (cl.id == event.id) {
						const eventData = {
							event: cl,
							order: event.order,
							parentId: transaction.id
						}

						dependEvents.push(eventData)
					}
				})
			})


			/**find nested transaction events */
			transaction.nestedTransactions.forEach(transaction => {
				const nestedTrans = allTransactions.find(item => item.id === transaction.id)
				const nestedTransEventIds = nestedTrans.events.map(item => item.id)
				clusterletEvents.forEach(ce => {
					if (nestedTransEventIds.includes(ce.id)) {
						const eventData = {
							event: ce,
							order: nestedTrans.events.find(item => item.id === ce.id).order,
							parentId: transaction.id
						}
						dispatch(deleteEventFromTransaction(nestedTrans.id, ce))
						nestedTransEvents.push(eventData)
					}
				})
			})

			let associatedUTs = []
			let associatedHandlers = []
			let associatedRRdefs = []

			console.log({ clusterletEvents })
			let clusterletTransactionEvents = [];


			//Filter all those events which are out of this transaction
			clusterletEvents.forEach(cEvent => {
				transaction.events.forEach(trEvent => {
					if (cEvent.id == trEvent.id) {
						clusterletTransactionEvents.push(cEvent);
					}
				})
			})



			clusterletTransactionEvents.forEach(event => {

				const userTriggerforEvent = userTriggers.filter(ut => ut.attributes.op === event.id);
				console.log({ userTriggerforEvent, event, userTriggers })
				if (userTriggerforEvent.length > 0) associatedUTs.push(...userTriggerforEvent);
				userTriggerforEvent.forEach(ut => dispatch(deleteUserTrigger(ut, true)));

				const luaForEvent = luaCodeData.filter(lua => lua.event == event.id);
				if (luaForEvent.length > 0) associatedHandlers.push(...luaForEvent);
				dispatch(onDeleteLuaFiles(luaForEvent, true));

				const rrdefforEvent = rrdefs.filter(rrdef => rrdef.attributes.tcmd === event.id);
				if (rrdefforEvent.length > 0) associatedRRdefs.push(...rrdefforEvent);
				rrdefforEvent.forEach(rrdef => dispatch(deleteRrdef(rrdef, true)))

				dispatch(deleteEventOnly(event))


			});

			eventAssociatedData.associatedUTs = associatedUTs;
			eventAssociatedData.associatedHandlers = associatedHandlers;
			eventAssociatedData.associatedRRdef = associatedRRdefs;
			eventAssociatedData.nestedTransEvents = nestedTransEvents;


			let newTranasaction = {
				...transaction,
				events: transaction.events.filter(event => !clusterletEventsIds.includes(event.id))
			}

			dispatch(dealWithTransactions(newTranasaction, 'edit', dependEvents, handlersToAdd, handlersToDelete, eventAssociatedData))
			dispatch(editTransaction(newTranasaction));
		}

		// dispatch(editTransaction(newTranasaction));
		dispatch(handleSnackBar({ open: true, message: "Tranaction updated!", severity: "success" }));

	} else {

		if (noUndoRedo != true) dispatch(dealWithTransactions(transaction, 'add'))

		dispatch(addTransaction(transaction));
		dispatch(handleSnackBar({ open: true, message: "Tranaction saved!", severity: "success" }));
	}
};

export const onDeleteTransaction = (payload, associatedData, noUndoRedo) => async (dispatch, getState) => {

	const handlers = getLuaEditorData(getState());
	const transactionList = await getTransaction(getState());
	const eventsInTransaction = getTransactionEvents(payload, getState());
	const nestedList = await getNestedTransactions(getState());
	const templateTransHandlers = handlers.filter(item => item.invokeId)

	let eventsForTransUndo = [];
	let nestedTransactionForUndo = [];
	let invokedTransactionForUndo = [];
	let nestedTransactionForParentTrans = [];
	const templateHandlers = templateTransHandlers.filter(item => payload.templateTransactions.map(e => e.invokeId).includes(item.invokeId))

	//if(eventsInTransaction.length > 0){
	if (associatedData.transactionEvents.length > 0) {
		associatedData.transactionEvents.forEach(events => {
			payload.events.forEach(eventInTrans => {
				if (eventInTrans.id === events.id) {
					const eventWithOrder = {
						event: events,
						order: eventInTrans.order,
						parentId: payload.id,
					}
					eventsForTransUndo.push(eventWithOrder);
				}
			})
		})
	}

	//if(nestedList.length > 0){
	if (associatedData.nestedTransactions.length > 0) {
		associatedData.nestedTransactions.forEach(nested => {
			payload.nestedTransactions.forEach(nestedTransLink => {
				if (nestedTransLink.id === nested.id) {
					const nestedWithOrder = {
						nestedTransaction: nested,
						order: nestedTransLink.order,
						parentId: payload.id,
					}
					nestedTransactionForParentTrans.push(nested);
					nestedTransactionForUndo.push(nestedWithOrder);
				}
			})
		})
	}

	nestedTransactionForParentTrans.forEach(nestedForPayload => {
		//const eventsForNested = getTransactionEvents(nestedForPayload, getState());
		associatedData.nestedTransactionEvents.forEach(event => {
			nestedForPayload.events.forEach(eventLink => {
				if (event.id === eventLink.id) {
					const eventWithOrder = {
						event: event,
						order: eventLink.order,
						parentId: nestedForPayload.id,
					}

					eventsForTransUndo.push(eventWithOrder);
				}
			})
		})
	})

	if (payload.invokedTransactions.length > 0) {
		payload.invokedTransactions.forEach(invoked => {
			invokedTransactionForUndo.push(invoked);
		})
	}

	const transactionAssociatedData = {
		events: eventsForTransUndo,
		eventHandlers: associatedData.handlersForEvents,
		nestedTransactions: nestedTransactionForUndo,
		invokedTRansactions: invokedTransactionForUndo,
		userTriggers: associatedData.userTriggersforEvents,
		rrdefs: associatedData.rrdefsforEvents,
		templateHandlers
	}

	if (noUndoRedo != true)
		dispatch(dealWithTransactions(payload, 'delete', transactionAssociatedData))


	dispatch(deleteTransaction(payload))
	dispatch(onDeleteLuaFiles(templateHandlers, true));

	dispatch(setSelectedTransactionId(transactionList[0].id))

};

export const nestedTransctionCreation = (transaction, noUndoRedo) => (dispatch, getState) => {
	const allTransactions = getAllTransactions(getState());

	const index = allTransactions.findIndex((i) => i.id === transaction.id);

	if (index > -1) {
		if (noUndoRedo != true) dispatch(dealWithNestedTransactions(transaction, undefined, 'edit'))

		dispatch(editNestedTransaction(transaction));
		dispatch(handleSnackBar({ open: true, message: "Nested Tranaction updated!", severity: "success" }));
	} else {
		dispatch(addTransaction(transaction));
		if (noUndoRedo != true) dispatch(dealWithNestedTransactions(transaction, undefined, 'add'))
		dispatch(handleSnackBar({ open: true, message: "Nested Tranaction saved!", severity: "success" }));

	}
};

export const addNestedTransction = (data) => (dispatch, getState) => {

	const selectedTransaction = getSelectedTransactions(getState());
	const allTransactions = getAllTransactions(getState());

	const index = allTransactions.findIndex((i) => i.id === selectedTransaction.id);
	const nestedIndex = allTransactions[index].nestedTransactions.findIndex((i) => i.id === data.id)

	if (nestedIndex == -1) {
		dispatch(addNestedTransaction(data, selectedTransaction.id));
	}
};

export const onNestedTransactionDelete = (nestedTransactionId, selectedTransactionId, noUndoRedo) => (dispatch, getState) => {

	const allTransactions = getAllTransactions(getState());
	const selectedTransaction = getSelectedTransactions(getState());
	const transactionList = getTransaction(getState());
	const nestedTransactionList = getNestedTransactions(getState());

	let eventsForUndo = [];

	const nestedTransaction = nestedTransactionList.find(nested => nested.id === nestedTransactionId);
	const orderOfNestedTransaction = selectedTransaction.nestedTransactions.find(nested => nested.id === nestedTransactionId).order;

	const eventsInNestedTransaction = getTransactionEvents(nestedTransaction, getState());

	if (eventsInNestedTransaction.length > 0) {
		eventsInNestedTransaction.forEach(eventInNested => {
			nestedTransaction.events.forEach(event => {
				if (event.id === eventInNested.id) {
					const eventWithOrder = {
						event: eventInNested,
						order: event.order,
					}

					eventsForUndo.push(eventWithOrder);
				}
			})
		})
	}

	const nestedAssociateData = {
		parentId: selectedTransaction.id,
		order: orderOfNestedTransaction,
		events: eventsForUndo,
	}

	if (noUndoRedo != true) dispatch(dealWithNestedTransactions(nestedTransaction, nestedAssociateData, 'delete'));

	const indexOfSelectedTransaction = allTransactions.findIndex((transaction) => transaction.id === selectedTransactionId)
	const indexOfNestedTransaction = allTransactions.findIndex((transaction) => transaction.id === nestedTransactionId)

	eventsInNestedTransaction.forEach(event => dispatch(deleteEvent(event, true)))

	batch(() => {
		dispatch(nestedTransactionDeletion(allTransactions[indexOfNestedTransaction]));
		dispatch(nestedTransactionLinkDelete(nestedTransactionId, selectedTransactionId));
	});
}

export const onTransactionInvoke = (selectedTransactionId, invokedTransaction, noUndoRedo) => (dispatch, getState) => {

	const transctionList = getTransaction(getState());
	const selectedTransaction = getSelectedTransactions(getState());
	const allTransactions = getAllTransactions(getState());

	const invokedTransactionIndex = selectedTransaction.invokedTransactions.findIndex((transaction) => transaction.id === invokedTransaction.id)

	if (invokedTransactionIndex > -1) {
		if (noUndoRedo != true) dispatch(dealWithInvokedTransaction(invokedTransaction, selectedTransaction.id, 'edit'))

		dispatch(editInvokedTransaction(invokedTransaction, selectedTransaction.id));
		dispatch(handleSnackBar({ open: true, message: "Invoked Tranaction updated!", severity: "success" }));
	}
	else {

		dispatch(addInvokedTransaction(invokedTransaction, selectedTransaction.id));

		if (noUndoRedo != true) dispatch(dealWithInvokedTransaction(invokedTransaction, selectedTransaction.id, 'add'))
		dispatch(handleSnackBar({ open: true, message: "Invoked the Tranaction!", severity: "success" }));




	}
};

export const onInvokedTransactionDelete = (invokedTransId, selectedTransactionId, noUndoRedo) => (dispatch, getState) => {

	const transactionList = getTransaction(getState());
	const parentTransaction = transactionList.find(transaction => transaction.id === selectedTransactionId);
	const invokedData = parentTransaction.invokedTransactions.find(invoked => invoked.id === invokedTransId);

	if (noUndoRedo != true) dispatch(dealWithInvokedTransaction(invokedData, selectedTransactionId, 'delete'));

	dispatch(deleteInvokedTransaction(invokedTransId, selectedTransactionId));
}

export const onReorderClusterlet = (selectedTransactionId, clusterletArray) => (dispatch, getState) => {
	
	const clusterletsOfSelectedTransaction = getSelectedTransactions(getState()).clusterlets;
	let item = {transactionId: selectedTransactionId, original: clusterletsOfSelectedTransaction, edited: clusterletArray};
	dispatch(dealWithReorderClusterlet(item));
	dispatch(reorderClusterlet(selectedTransactionId, clusterletArray));
}

/** Add event to a transaction */
export const addEventToTransaction = (selectedTransactionId, eventId, order) => {
	let payload = { selectedTransactionId, event: { id: eventId, order } }
	return { type: types.ADD_EVENT_TO_TRANSACTION, payload }
}

/** Delete event from a transaction */
export const deleteEventFromTransaction = (transactionId, event) => {
	let payload = { transactionId, eventId: event.id }
	return { type: types.DELETE_EVENT_FROM_TRANSACTION, payload: payload }
}

export const updateFullTransactions = (transactions) => ({
	type: types.UPDATE_FULL_TRANSACTIONS,
	payload: transactions
})

export const addTemplateTransaction = (templateTransaction, selectedTransactionId, handlers, noUndoRedo) => (dispatch, getState) => {

	if (noUndoRedo != true) dispatch(dealWithTemplateTransaction(templateTransaction, selectedTransactionId, handlers, 'add'));

	dispatch({
		type: types.ADD_TEMPLATE_TRANSACTION,
		payload: {
			templateTransaction,
			selectedTransactionId
		},
	})
}

export const deleteTemplateTransaction = (templateTransaction, selectedTransactionId, associatedData, noUndoRedo) => (dispatch, getState) => {

	if (noUndoRedo != true) dispatch(dealWithTemplateTransaction(templateTransaction, selectedTransactionId, associatedData, 'delete'));

	dispatch({
		type: types.DELETE_TEMPLATE_TRANSACTION,
		payload: {
			templateTransactionInvokeId: templateTransaction.invokeId,
			selectedTransactionId
		},
	})
}

export const removeTemplateTransaction = (templateClusterletIds, selectedTransactionId) => ({
	type: types.REMOVE_TEMPLATE_TRANSACTION,
	payload: {
		templateClusterletIds, selectedTransactionId
	},
})


export const addClusterletToTransaction = (payload) => ({
	type: types.ADD_CLUSTERLET_TO_TRANSACTION,
	payload,
})

export const removeClusterletFromTransaction = (payload) => ({
	type: types.REMOVE_CLUSTERLET_FROM_TRANSACTION,
	payload,
})

export const resetTransactions = (transactions) => ({
	type: types.RESET_TRANSACTIONS,
	payload: transactions
})


export const editOrder = (payload) => ({
	type: types.EDIT_EVENT_ORDER,
	payload,
})


export const editEventOrder = (payload) => (dispatch, getState) => {

	const allTransactions = getAllTransactions(getState());

	let transactionId = ''
	allTransactions.forEach(trans => {
		let transactionEvents = trans.events.some(event => event.id == payload?.event?.id);
		if (transactionEvents) {
			transactionId = trans.id
		}

	})

	payload = {
		...payload,
		transactionId: transactionId
	}


	dispatch(editOrder(payload))
}

